import { en } from "./en";
import type { Glossary } from "./types";

const generateKeys = <T>(obj: T, prefix = ""): T => {
  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(obj as object)) {
    const path = prefix ? `${prefix}.${key}` : key;
    if (typeof value === "function") {
      result[key] = () => path;
    } else if (typeof value === "object" && value !== null) {
      result[key] = generateKeys(value, path);
    } else {
      result[key] = path;
    }
  }
  return result as T;
};

export const keys = generateKeys(en) as Glossary;
